import styled from "styled-components";
export const UserContainer = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
`;

export const UserWrapper = styled.div`
  display: flex;
  flex-flow: column;
  background-color: #fff;
  width: 100%;
  box-sizing: border-box;
  box-shadow: 0 2px 8px rgb(28 28 28 / 14%);
  > span {
    margin: 5px 0;
    text-align: left;
  }
  > span > span {
    margin-left: 10px;
    font-weight: 600;
  }
  border-radius: 8px;
  padding: 10px;
  margin: 10px 0;
  @media screen and (max-width: 568px) {
    width: 90%;
  }
`;

export const StatusWrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  > button {
    margin: 10px;
  }
  button:first-child {
    margin: 10px 10px 10px 0;
  }
  @media screen and (max-width: 568px) {
    button:last-child {
      margin: 10px 10px 10px 0;
    }
  }
`;
